// extracted by mini-css-extract-plugin
export var languages = "styles-module--languages--IIt8s";
export var languageTitle = "styles-module--languageTitle--2m1nd";
export var language = "styles-module--language--1oFnS";
export var selectedLanguage = "styles-module--selectedLanguage--2Hgot";
export var options = "styles-module--options--2noIn";